import React, { FC } from 'react';
import classNames from 'classnames';

import { useTranslation } from 'app/lang';
import { formatMoney } from 'app/lib/formatters';

import CurrencySymbol, { CurrencySymbolProps } from '../CurrencySymbol';

import styles from './Amount.module.scss';

export type AmountProps = {
  value: number;
  className?: string;
};

export const Amount: FC<AmountProps & CurrencySymbolProps> = ({
  value,
  currency,
  className,
}) => {
  const { lang } = useTranslation();

  // Строковое представление на текущем языке и максимум два знака после запятой
  const stringValue = formatMoney(value, lang, true, 2);

  const _className = classNames(
    styles.amountWrapper,
    className,
  );

  // Символ валюты справа или слева
  switch (lang) {
    case 'en':
      return (
        <span className={_className}
              data-test="amount">
          <CurrencySymbol currency={currency} />
          &nbsp;
          <span data-test="amountValue">
            {stringValue}
          </span>
        </span>
      );
    default:
      return (
        <span className={_className}
              data-test="amount">
          <span data-test="amountValue">
            {stringValue}
          </span>
          &nbsp;
          <CurrencySymbol currency={currency} />
        </span>
      );
  }
};
